import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel"]

  connect() {
    this.panelTarget.addEventListener("click", this.handleClick.bind(this))
  }

  disconnect() {
    this.panelTarget.removeEventListener("click", this.handleClick.bind(this))
  }

  async submit(event) {
    event.preventDefault()

    const url = event.target.action
    const formData = new FormData(event.target)
    const queryString = new URLSearchParams(formData).toString()

    const response = await fetch(`${url}?${queryString}`, {
      headers: { "Accept": "text/html" }
    })
    this.panelTarget.innerHTML = await response.text()
  }

  async handleClick(event) {
    const link = event.target.closest("a")
    if (!link || !link.href.includes("page=")) return

    event.preventDefault()
    const response = await fetch(link.href, {
      headers: { "Accept": "text/html" }
    })
    this.panelTarget.innerHTML = await response.text()
  }
}
